module.exports = __webpack_public_path__ + "static/img/regionostergotland.5aa531f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/graphics/regionostergotland.png
// module id = WWn1
// module chunks = 0